import React from "react";
import { ENTITY_TYPE } from "../config/constants";

export const entityToHTML = styles => (entity, originalText) => {
  if (entity.type.toLowerCase() === ENTITY_TYPE.LINK) {
    return <a href={entity.data.url} className={styles.link} />;
  }
  return originalText;
};
